import { useMemo } from 'react';
import React from 'react';
import { UseModalProps } from '../types/modal-types';

export const useModal = ({
  size,
  overlayStyle = {},
  modalStyle = {},
  headerStyle = {},
  bodyStyle = {},
  footerStyle = {}
}: UseModalProps) => {

  const sizes = useMemo(() => ({
    small: { maxWidth: '400px' },
    medium: { maxWidth: '600px' },
    large: { maxWidth: '900px' },
    full: { maxWidth: '95vw' }
  }), []);

  const defaultOverlayStyle: React.CSSProperties = useMemo(() => ({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px',
    ...overlayStyle
  }), [overlayStyle]);

  const defaultModalStyle: React.CSSProperties = useMemo(() => ({
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    ...sizes[size],
    width: '100%',
    maxHeight: '90vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    ...modalStyle
  }), [size, modalStyle, sizes]);

  const defaultHeaderStyle: React.CSSProperties = useMemo(() => ({
    padding: '20px 24px',
    borderBottom: '1px solid #e5e7eb',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    ...headerStyle
  }), [headerStyle]);

  const defaultBodyStyle: React.CSSProperties = useMemo(() => ({
    padding: '24px',
    overflowY: 'auto',
    flex: 1,
    ...bodyStyle
  }), [bodyStyle]);

  const defaultFooterStyle: React.CSSProperties = useMemo(() => ({
    padding: '16px 24px',
    borderTop: '1px solid #e5e7eb',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    ...footerStyle
  }), [footerStyle]);

  return {
    defaultOverlayStyle,
    defaultModalStyle,
    defaultHeaderStyle,
    defaultBodyStyle,
    defaultFooterStyle
  };
};

